<template>
    <div >
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <div slot="headerBtns">
                <button class="h_search_btn" @click="$router.push('/search')"></button>
            </div>
        </page-header>
        <page-header class="sub_header"></page-header>
<!--        <page-header :header_back="true"  :header_setting="true"></page-header>-->
        <member-write-component :memberType="'portfolioEdit'" :memberKey="UserInfo.mb_no"></member-write-component>
    </div>
</template>

<script>
import MemberWriteComponent from "@/components/member/MemberWriteComponent";
import AuthMixins from "@/mixins/AuthMixins";
export default {
    name: "PortfolioEdit",
    mixins: [AuthMixins],
    components: {
        MemberWriteComponent,
    },
    inject: [],
    provide() {
        return{

        }
    },
    props: {
    },
    data() {
        return{

        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{

    },
    watch: {

    },
}
</script>

<style scoped>

</style>
